import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from 'dayjs';

export default function DatePickerComponent({ classname,value,onChange }) {
    const date = dayjs().subtract(15, 'year');
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                className={classname}
                label="DOB"
                value={value}
                maxDate={date}
                onChange={onChange}
                name="dob"
            />
        </LocalizationProvider>
    );
}
